export enum RegNumbersEnum {
    kpp = 'kpp',
    inn = 'inn',
    ogrn = 'ogrn',
}